import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface CitiServiceConfigOptions extends ApiConfigOptions {}
export class CitiServiceConfig extends Configuration {
  constructor(configOptions?: CitiServiceConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
